import React from "react";
import { Link } from "react-router-dom";
import { useBranding } from "@/context/BrandingContext";
import { resolveTenantLogo } from "@/lib/logoResolver";

/* Tenant identity on the Dynicty auth card — logo comes ONLY from the
   existing Admin Panel branding (`/api/public/branding` → resolveTenantLogo). */
export function TenantEmblem() {
  const { branding } = useBranding();
  const [failed, setFailed] = React.useState(false);
  const name = branding.general.name;
  const resolved = resolveTenantLogo(branding.visual, name);
  const showImg = resolved.type !== "initial" && !failed;

  return (
    <Link to="/" className="inline-flex items-center justify-center bg-white rounded-2xl p-2.5 shadow-[0_8px_25px_rgba(0,0,0,0.3)] border border-slate-100/20 min-w-20 h-20 max-w-[220px]" data-testid="brand-logo-stacked">
      {showImg ? (
        <img
          src={resolved.src}
          alt={`${name} logo`}
          onError={() => setFailed(true)}
          className="h-full w-auto max-w-full object-contain"
          data-testid={resolved.type === "horizontal" ? "brand-logo-horizontal-auth" : "brand-logo-icon-auth"}
        />
      ) : (
        <span className="grid place-items-center w-14 h-14 rounded-xl font-extrabold text-white text-2xl" style={{ background: "linear-gradient(135deg, #3B82F6, #A855F7)" }} data-testid="brand-logo-initial">
          {resolved.initial || (name || "?").trim().charAt(0).toUpperCase()}
        </span>
      )}
    </Link>
  );
}
